import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../App";
import background from "../assets/images/splash_bg.jpeg";
import mark from "../assets/images/zylen-mark-white.png";
import wordmark from "../assets/images/zylen-wordmark-white.png";

const MINIMUM_HOLD_MS = 1500;
const LOAD_GRACE_MS = 1200;

export default function Splash() {
  const navigate = useNavigate();
  const [backgroundReady, setBackgroundReady] = useState(false);
  const [markReady, setMarkReady] = useState(false);
  const [wordmarkReady, setWordmarkReady] = useState(false);
  const ready = backgroundReady && markReady && wordmarkReady;
  const navigated = useRef(false);
  const finish = useCallback(() => {
    if (navigated.current) return;
    navigated.current = true;
    let returning = false;
    try {
      returning = Boolean(localStorage.getItem("isNotFirstTime"));
    } catch {
      // Storage can be unavailable in a restricted browser session.
    }
    navigate(returning ? ROUTES.SIGN_IN : ROUTES.ONBOARDING, {
      replace: true,
    });
  }, [navigate]);

  useEffect(() => {
    const timer = setTimeout(finish, MINIMUM_HOLD_MS + LOAD_GRACE_MS);
    return () => clearTimeout(timer);
  }, [finish]);

  useEffect(() => {
    if (!ready) return;
    // Allow a frame for the composition to paint before starting its hold.
    let timer;
    const frame = requestAnimationFrame(() => {
      timer = setTimeout(finish, MINIMUM_HOLD_MS);
    });
    return () => {
      cancelAnimationFrame(frame);
      clearTimeout(timer);
    };
  }, [finish, ready]);

  return (
    <main
      aria-label="Opening Zylen"
      className="fixed inset-0 z-[10000] h-[100dvh] w-full overflow-hidden bg-[#082B3D]"
    >
      <img
        src={background}
        alt=""
        aria-hidden="true"
        loading="eager"
        decoding="sync"
        onLoad={() => setBackgroundReady(true)}
        onError={() => setBackgroundReady(true)}
        className="absolute inset-0 h-full w-full object-cover"
      />

      <div
        className={`absolute inset-0 grid place-items-center ${backgroundReady ? "opacity-100" : "opacity-0"}`}
      >
        <img
          src={mark}
          alt=""
          aria-hidden="true"
          loading="eager"
          decoding="sync"
          onLoad={() => setMarkReady(true)}
          onError={() => setMarkReady(true)}
          width={140}
          height={140}
          className="h-[140px] w-[140px] object-contain"
        />
      </div>

      <div
        className={`absolute inset-x-0 bottom-[calc(env(safe-area-inset-bottom,0px)+32px)] flex justify-center ${backgroundReady ? "opacity-100" : "opacity-0"}`}
      >
        <img
          src={wordmark}
          alt=""
          aria-hidden="true"
          loading="eager"
          decoding="sync"
          onLoad={() => setWordmarkReady(true)}
          onError={() => setWordmarkReady(true)}
          width={138}
          height={37}
          className="h-[37px] w-[138px] object-contain"
        />
      </div>
      <span className="sr-only">Zylen</span>
    </main>
  );
}

